import { render, staticRenderFns } from "./chooseCrystalItem.vue?vue&type=template&id=7b394cee&scoped=true&"
import script from "./chooseCrystalItem.vue?vue&type=script&lang=js&"
export * from "./chooseCrystalItem.vue?vue&type=script&lang=js&"
import style0 from "./chooseCrystalItem.vue?vue&type=style&index=0&id=7b394cee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b394cee",
  null
  
)

export default component.exports